import { COUNTRY_FACET, DISCIPLINE_FACET } from '../interfaces/create-search-filter.interface';
import { SearchFacet } from '../../../search/interfaces/search.interface';
import { StoreState } from '../../../../store/store.interface';

/*----- SELECTORS ------*/
export const createSearchParam = (state: StoreState) => state.createSearchState.search?.request?.searchValue;
export const isCreateSearchFailure = (state: StoreState) => state.createSearchState.search?.isFailure;
export const isCreateSearchLoaded = (state: StoreState) => state.createSearchState.search?.isLoaded;
export const isCreateSearchLoading = (state: StoreState) => state.createSearchState?.search?.isLoading || false;
export const isCreateSearchSuccess = (state: StoreState) => state.createSearchState.search?.isSuccess;
export const selectCreateRequest = (state: StoreState) => state.createSearchState.search?.request;
export const selectCreateResults = (state: StoreState) => state.createSearchState.search?.data?.hits;
export const selectCreateSearchTotal = (state: StoreState) => state.createSearchState.search?.data?.total;

/**
 * Selects the facets for Create search.
 * Ensures the country facet is created from a static list of countries.
 * It is then updated with the selected value from the actual facet.
 *
 * @param state
 * @param countryFacet
 */
export const selectCreateFacets = (state: StoreState, countryFacet?: SearchFacet): SearchFacet[] => {
  const facets = state.createSearchState.search?.data?.facets || [];
  if (!countryFacet || countryFacet.facetValues.length === 0) {
    return facets;
  }

  const originalCountryFacet = facets.find((f) => f.name === COUNTRY_FACET);
  if (!originalCountryFacet) {
    facets.unshift(countryFacet);
  }

  const selectedValue = originalCountryFacet?.facetValues?.find((v) => v.selected)?.name;
  const countryFacetValues = countryFacet.facetValues.map((facetValue) => ({
    ...facetValue,
    selected: facetValue.name === selectedValue,
  }));

  const updatedFacets = facets
    .filter((facet) => facet.name !== DISCIPLINE_FACET)
    .map((facet) => {
      if (facet.name === COUNTRY_FACET) {
        return {
          ...facet,
          facetValues: countryFacetValues,
        };
      }
      return facet;
    });

  return updatedFacets.sort((facetA) => (facetA.name === COUNTRY_FACET ? -1 : 1));
};

export const selectedCreateFacetCount = (state: StoreState): number => {
  const facets = state.createSearchState.search?.request?.fieldValueFilter || {};
  return Object.keys(facets).reduce((count: number, key: string) => {
    if (facets[key] && facets[key].length > 0) count += facets[key].length;
    return count;
  }, 0);
};
